// frontend/src/utils/documentStatus.js

/**
 * Calcule le statut global d'un type de document en fonction de ses fichiers et de ses règles.
 * @param {object} document - L'objet document contenant les règles et la liste des fichiers.
 * @returns {string} Le statut calculé ('Validé', 'Rejeté', 'En attente', 'Fourni', etc.)
 */
export function calculateDocumentStatus(document) {
  if (!document) return 'À fournir';

  // Règle 1: Le statut de l'admin est prioritaire.
  if (document.status === 'Validé' || document.status === 'Rejeté') {
    return document.status;
  }

  const allFiles = document.files || [];
  
  // Règle 2: Si aucun fichier n'a été fourni
  if (allFiles.length === 0) {
    return document.optional ? 'Optionnel' : 'À fournir';
  }

  // Règle 3: Si au moins un fichier est 'Rejeté' par un admin.
  if (allFiles.some(file => file.status === 'Rejeté')) {
    return 'Rejeté';
  }
  
  // Règle 4: Si tous les fichiers sont 'Validé'
  if (allFiles.every(file => file.status === 'Validé')) {
    return 'Validé';
  }

  // Règle 5: Si au moins un fichier a été soumis (et pas encore validé ou rejeté)
  // C'est le cas le plus courant pour "En attente".
  // Note : 'Fourni' et 'Fourni partiellement' sont des nuances de 'En attente'.
  if (allFiles.some(file => file.status === 'En attente' || file.status === 'Fourni')) {
     // Ici, vous pourriez ajouter la logique complexe pour "Fourni" vs "Fourni partiellement"
     // si nécessaire. Pour l'instant, "En attente" est un bon statut global.
    return 'En attente';
  }
  
  // Cas par défaut : si aucun des cas ci-dessus ne correspond (ne devrait pas arriver souvent)
  return document.optional ? 'Optionnel' : 'À fournir';
}